import { useEffect } from 'react';
import { useState } from 'react';

export const useModal = ({ showModal: showModalDefault = false } = {}) => {
  useEffect(() => {
    setShowModal(showModalDefault);
  }, [showModalDefault]);

  const [showModal, setShowModal] = useState(showModalDefault);

  return {
    closeModal: () => {
      setShowModal(false);
    },
    openModal: () => setShowModal(true),
    open: showModal,
  };
};
